import { Options } from '@sheerid/jslib';
import { messagesEN } from './lib/intl/en-US';
import { messagesES } from './lib/intl/es';
import { RecursivePartial } from './lib/types/types';


export const programId = '5f848bc54fdde418a6a249bc';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
        es: messagesES,
    },
};
